import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=20daaf9e&scoped=true&"
import script from "./AdminSettings.vue?vue&type=script&lang=js&"
export * from "./AdminSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=20daaf9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20daaf9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20daaf9e')) {
      api.createRecord('20daaf9e', component.options)
    } else {
      api.reload('20daaf9e', component.options)
    }
    module.hot.accept("./AdminSettings.vue?vue&type=template&id=20daaf9e&scoped=true&", function () {
      api.rerender('20daaf9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/AdminSettings.vue"
export default component.exports